import styled from "styled-components";

export const UploaderWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  left: 0;
  right: 0;
  transition: all 0.2s;
  opacity: 0;
`;
export const UploadCloudIcon = styled.img`
  ${(props) =>
    props.small
      ? `
  height: 20px;
  width: 20px;
  margin: 4px 2px;
  `
      : `
  margin: 11px 9px;
  height: 32px;
  width: 32px;
  `}
`;
export const CreativeWrapper = styled.div`
  display: flex;
  align-items: center;
  width: ${(props) => props.width}px;
  min-height: 50px;
  video,
  img {
    display: flex;
    object-fit: cover;
    max-width: none;
    width: 100%;
    height: 100%;
    min-height: ${(props) => props.minHeight}px;
    max-height: ${(props) => props.maxHeight}px;
  }
`;

export const DefaultImageWrapper = styled.div`
  display: flex;
  align-items: center;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  video,
  img {
    display: flex;
    object-fit: cover;
    max-width: none;
    width: 100%;
    height: 100%;
  }
`;

export const CreativeAndUploaderWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  &:hover {
    ${UploaderWrapper} {
      opacity: 1;
    }
  }
`;
export const EditorWrapper = styled.div`
  color: black;
  & .pictureFader-enter {
    opacity: 0.4;
  }
  & .pictureFader-exit {
    opacity: 1;
  }
  & .pictureFader-enter-active {
    opacity: 1;
  }
  & .pictureFader-exit-active {
    opacity: 0.4;
  }
  & .pictureFader-enter-active,
  & .pictureFader-exit-active {
    transition: opacity 0.3s;
  }
`;
export const MediaLibraryOpenButton = styled.button`
  border: 1px solid #e8e8eb;
  background-color: #fff;
  opacity: 0.9;
  border-radius: 100%;
  transition: all 0.2s;
  box-shadow: 0px 0px 0px 800px rgb(30 31 70 / 50%);
  cursor: pointer;
  padding: 0px 2px;
  &:hover {
    opacity: 1;
  }
`;
export const CreativeButton = `
  cursor: pointer;
  use-select: none;
  border-radius: 100%;
  padding: 0px;
  border: none;
  transition: all .2s;
  background-color: #fff;
  opacity: 0.5;
  width: 26px;
  height: 26px;
  &:hover {
    opacity: 1;
    transform: scale(1.1);
  }
`;

export const SaveButton = styled.button`
  position: absolute;
  bottom: 16px;
  right: 16px;
  background-color: var(--primary-green);
  color: var(--primary-dark-600);
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: var(--fs-base);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;

  &:hover {
    background-color: var(--primary-green);
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;
